import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "notification-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_notification_icon_content = _resolveComponent("notification-icon-content")!
  const _component_notification_owner_content = _resolveComponent("notification-owner-content")!
  const _component_notification_redirect_content = _resolveComponent("notification-redirect-content")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_notification_detail = _resolveComponent("notification-detail")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { md: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mt-3" }, "Notification List", -1)),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(_component_v_switch, {
                        label: "Unread",
                        modelValue: _ctx.isRead,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isRead) = $event)),
                        color: "success"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_spacer)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "notif-card-text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    items: _ctx.notifications,
                    headers: _ctx.headers,
                    loading: _ctx.loading,
                    "items-per-page": _ctx.numberOfPages,
                    "onUpdate:options": _cache[1] || (_cache[1] = (event) => _ctx.tableOptions = event),
                    "items-length": _ctx.totalItemsCount
                  }, {
                    "item.IsNew": _withCtx(({ item }) => [
                      _createVNode(_component_notification_icon_content, {
                        item: item,
                        class: "inner-icon"
                      }, null, 8, ["item"])
                    ]),
                    "item.ShortDesc": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.ShortDesc), 1)
                    ]),
                    "item.Text": _withCtx(({ item }) => [
                      _createElementVNode("p", _hoisted_1, _toDisplayString(item.Text), 1)
                    ]),
                    "item.Info": _withCtx(({ item }) => [
                      _createVNode(_component_notification_owner_content, {
                        item: item,
                        userId: _ctx.userId,
                        isOwner: _ctx.isNotificationCreator(item)
                      }, null, 8, ["item", "userId", "isOwner"])
                    ]),
                    "item.Actions": _withCtx(({ item }) => [
                      _createVNode(_component_notification_redirect_content, {
                        item: item,
                        userId: _ctx.userId,
                        isTeamMember: _ctx.isTeamMember,
                        isAdmin: _ctx.isAdmin,
                        isClient: _ctx.isClient
                      }, null, 8, ["item", "userId", "isTeamMember", "isAdmin", "isClient"]),
                      _createVNode(_component_v_icon, {
                        icon: "",
                        fab: "",
                        "x-small": "",
                        title: "View Notification",
                        class: _normalizeClass({ 'not-seen': !_ctx.isSeen(item) }),
                        onClick: ($event: any) => (_ctx.showDetail(item))
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-eye-outline")
                        ])),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["items", "headers", "loading", "items-per-page", "items-length"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.showDetailPopUp)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 0,
            "onClick:outside": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickedOutside())),
            modelValue: _ctx.showDetailPopUp,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDetailPopUp) = $event)),
            persistent: "",
            width: "800px",
            onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showDetailPopUp = false), ["esc"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_notification_detail, {
                userId: _ctx.userId,
                isClient: _ctx.isClient,
                isAdmin: _ctx.isAdmin,
                isTeamMember: _ctx.isTeamMember,
                onMakeSeen: _ctx.makeSeen,
                onInitNotifications: _ctx.initNotifications,
                notificationItem: _ctx.selectedItem,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailPopUp = false))
              }, null, 8, ["userId", "isClient", "isAdmin", "isTeamMember", "onMakeSeen", "onInitNotifications", "notificationItem"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}